import React from "react";
import { Select, Row, Col, Form, Input, Radio, InputNumber } from "antd";
import { FormRenderer } from "mr_react_framework";
import { buildOptionsArr, buildSchemaObject } from "../../../lib/utils/helperMethods";
import CKETextContent from "../CKETextContent/CKETextContent";
// import MrTranslate from "lib/MrTranslate/MrTranslate";
// import MrTranslate from "lib/MrTranslate/MrTranslate";

const textForm = (mrIntl) => {
  return {
    type: "object",
    properties: {
      content: {
        type: "string",
        title: mrIntl("TextForm.text_content"),
        // title: "Text content",
        widget: CKETextContent,
        widgetConfig: {
          writingAssistantConfig: {
            enabled: true
          }
        },
        setInitialValue: true,
        rules: [{
          required: true,
          message: mrIntl("CommonText.required_msg")
        }]
      }
    }
  }
};

export default textForm;